import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StatusDTO } from 'src/app/shared/Models/Models';
import { StepCompletionStatusComponent } from 'src/app/step-completion-status/step-completion-status.component';

@Component({
    selector: 'app-vehicle-found',
    templateUrl: './vehicle-found.component.html',
    styleUrls: ['./vehicle-found.component.scss'],
    standalone: false
})
export class VehicleFoundComponent implements OnInit {
  vehicleAlreadyAssociated :boolean = false; // use this to display different type of vehicle found pop up
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VehicleFoundComponent>,
    private dialog: MatDialog
    ) {
    // 
   }

  ngOnInit(): void {
  }

  onClickAddThisVehicle(){
    // after api call result
    let statusData: StatusDTO = {
      title: "",
      details: "Your Vehicle has been added successfully",
      stepSuccessful: true
  }
    this.dialogRef.close();
    this.dialog.open(StepCompletionStatusComponent, { height: '45vh', width: '40vw', data: statusData})
  }

}
